import React from 'react';
import '../../../assests/css/students/About.css';
import Missionsection from '../../students/Missionsection/Missionsection';
import Vision from '../../students/Vision/Vision';
import StatsCounter from '../../../subscreens/StatsCounter/StatsCounter';
import TopHero from '../../../subscreens/TopHero/TopHero';

const About = () => {
  const stats = [
    { number: '500+', label: 'Students Enrolled' },
    { number: '50+', label: 'Expert Instructors' },
    { number: '100+', label: 'Courses Available' },
    { number: '95%', label: 'Success Rate' }
  ];

  const features = [
    {
      icon: '🎓',
      title: 'Quality Education',
      description: 'Learn from industry experts with years of practical experience in their fields.'
    },
    {
      icon: '💼',
      title: 'Career Support',
      description: 'Get placement assistance and career guidance to land your dream job.'
    },
    {
      icon: '🌐',
      title: 'Online & Offline',
      description: 'Flexible learning options with both online and in-person classes available.'
    },
    {
      icon: '📚',
      title: 'Updated Curriculum',
      description: 'Stay ahead with courses updated regularly to match industry standards.'
    }
  ];

  return (
    <div className="about-container">
        {/* 🔥 HERO SECTION WITH VIDEO */}
      {/* ================= HERO ================= */}
      <TopHero
  title="About Us"
  description="Learn more about our university, our mission, values, and commitment to academic excellence."
/>
      {/* <section className="contact-hero">
        <div className="hero-bg"></div>
        <div className="hero-overlay"></div> */}

        {/* HERO CONTENT (Moved from Contact Info Section) */}
        {/* <div className="hero-content">
          <h2>About Us</h2>
        <p>
  For any information about the University, its history, mission, and
  programs, please read about us below. You can also find details about
  our leadership, achievements, and initiatives to learn more about the
  institution.
</p>

        </div>
      </section> */}
      {/* Main About Content */}
      <section className="about-content">
        <div className="about-wrapper">
          <div className="about-text">
            <h2 className="about-heading">Who We Are</h2>
            <p className="about-paragraph">
            GGC Gujranwala is a leading public sector educational institution committed to delivering quality education in technology and language studies. Located in Gujranwala, the college focuses on equipping students with essential skills in programming, web development, and language learning to meet academic and professional demands. Since its establishment, GGC Gujranwala has played a vital role in empowering students through education, fostering innovation, critical thinking, and lifelong learning.
            </p>
            <p className="about-paragraph">
              Our mission is to bridge the gap between traditional education and industry 
              requirements, ensuring our students are job-ready and equipped with practical 
              skills that matter in today's competitive world.
            </p>
            <p className="about-paragraph">
              With a team of experienced instructors and a curriculum designed around real-world 
              applications, we provide an environment where learning meets innovation.
            </p>
          </div>
          <div className="about-image">
            <div className="about-image-placeholder">
              <span className="image-icon">📖</span>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <StatsCounter />

      {/* Mission Section - NEW */}
      <Missionsection />

      {/* Vision Section (Simplified - Mission is now separate) */}
      <Vision />
    </div>
  );
};

export default About;